/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:25]
Permissions to update outside the main branch: [false]
*/

import { TFunction } from 'react-i18next';

export default function errorToText(
    reactQueryError: {
        response?: {
            data?: { errorCode?: string; message: string };
            status: string;
            statusText: string;
        };
    },
    translator: TFunction<'translation', undefined>
) {
    const errorCode = reactQueryError?.response?.data?.errorCode;
    const message = reactQueryError?.response?.data?.message;
    const status = reactQueryError?.response?.status;
    const statusText = reactQueryError?.response?.statusText;

    if (errorCode) {
        return `${translator('BackOfficeError')}! ${translator(errorCode)}`;
    } else if (message) {
        return `${translator('BackOfficeError')}! ${message}`;
    } else if (status != null && statusText != null) {
        return `${translator('BackOfficeError')}! ${status} ${statusText}`;
    }

    return `${translator('BackOfficeError')}!`;
}
